import { graphql } from "react-relay";

export const UpdateDatadogIntegrationMutation = graphql`
  mutation UpdateDatadogIntegrationMutation(
    $input: UpdateDatadogIntegrationInput!
  ) {
    updateDatadogIntegration(input: $input) {
      datadogIntegration {
        configured
        enabled
        site
        statusInfo {
          details {
            at
            component
            message
            status
          }
          status
        }
      }
      problems {
        message
      }
    }
  }
`;
